import React, { useEffect, useState } from "react";
import SingleSelectBox from "../../components/FormComponents/SingleSelectBox";
import Button from "../../components/FormComponents/Button";
import axiosInstance, { handleApiError } from "../../services/axiosService";

const CloneApplicationModal = ({ editData, addApplication }) => {
  const [applicationData, setApplicationData] = useState(editData);
  const [organisations, setOrganisations] = useState([]);
  const [selectedOrganisations, setSelectedOrganisations] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const fetchOrganisations = async () => {
    try {
      const { data } = await axiosInstance.get(`/organisations`);
      setOrganisations(data);
    } catch (error) {
      handleApiError(error);
    }
  };

  const cloneApplication = async (applicationData) => {
    try {
      setIsLoading(true);
      await addApplication(applicationData);
      setIsLoading(false);
    } catch (error) {
      handleApiError(error);
    }
  };
  useEffect(() => {
    fetchOrganisations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleSelectChange = (id) => {
    if (id) {
      for (let index = 0; index < organisations.length; index++) {
        const element = organisations[index];
        if (element.id === id) {
          setSelectedOrganisations(element);
          break;
        }
      }
    } else {
      setSelectedOrganisations({});
    }
  };
  return (
    <div className="builder_form">
      <SingleSelectBox
        selectedData={selectedOrganisations?.id || ""}
        options={organisations || []}
        onChange={(obj) => handleSelectChange(obj.id)}
        placeholder="Select Organization"
        label="Organization"
        isSearch={true}
      />

      <SingleSelectBox
        selectedData={applicationData?.source_app_id || ""}
        options={selectedOrganisations?.apps || []}
        onChange={(obj) => setApplicationData({ ...applicationData, source_app_id: obj.id })}
        placeholder="Select Application"
        label="Application"
        isSearch={true}
      />
      <Button
        // isLoading={isLoading}
        disabled={applicationData.source_app_id ? false : true}
        onClick={() => cloneApplication(applicationData)}
        isLoading={isLoading}
      >
        Clone Application
      </Button>
    </div>
  );
};
export default CloneApplicationModal;
